import classNames from 'classnames';
import { MouseEventHandler } from 'react';

import { Plus } from '@zooplus/icons';

import styles from '../StoredCreditCards/StoredCreditCards.module.scss';

import { useTranslation } from '@hooks/useTranslations';
import { handleKeyDown } from '@utils/utils';

export type AddCardProps = {
  onClick?: MouseEventHandler;
};

const NewCardActionButton: React.FC<AddCardProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.creditCardContainer}>
      <div
        className={classNames(styles.creditCard, styles.addCard)}
        data-zta="addNewCC"
        onClick={onClick}
        onKeyDown={(e) => handleKeyDown(e, onClick)}
        role="button"
        tabIndex={0}>
        <div>
          <Plus />
        </div>
        <div>{t('checkout.payment.creditcard.addnew')}</div>
      </div>
    </div>
  );
};

export default NewCardActionButton;
